import { Patent } from 'fobclient/lib/entity'
import ExterneOrganisation from './ExterneOrganisation'
import AbstractPerson from './AbstractPerson'
import Person from './Person'
import Land from './Land'
import Organisationseinheit from './Organisationseinheit'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Patent')

export default {
  label: 'Patent',
  route: 'patent',
  className: 'patent',
  class: Patent,
  entityName: 'de.ul.fob.domain.Patent',
  fields: [
    Fields.organisationseinheit,
    Fields.String('titel'),
    Fields.String('veroeffentlichungsnummer'),
    Fields.Date('datumDerPrioritaetsbegruendendenErstanmeldung'),
    {
      label: 'Patent.form.haupterfinder',
      field: 'haupterfinder',
      schema: AbstractPerson,
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      },
      icon: 'user',
      type: 'object',
      cardinality: 'many',
      render: 'stringRep'
    },
    {
      label: `Patent.form.anmelderExtern`,
      singularLabel: 'Organisationseinheit',
      field: 'anmelderExtern',
      type: 'object',
      render: 'stringRep',
      icon: 'sitemap',
      cardinality: 'many',
      method: 'bySearchRepLike',
      schema: ExterneOrganisation,
      finder: {
        name: 'bySearchRepLike',
        multiValue: false,
        minLength: 0
      },
      allowCreate: true
    },
    {
      label: `Patent.form.anmelderIntern`,
      singularLabel: 'Organisationseinheit',
      field: 'anmelderIntern',
      type: 'object',
      render: 'stringRep',
      icon: 'sitemap',
      cardinality: 'many',
      method: 'bySearchRepLike',
      schema: Organisationseinheit,
      finder: {
        name: 'bySearchRepLikeUnrestricted',
        multiValue: false,
        minLength: 0
      },
      allowCreate: true
    },
    Fields.Text('lizenzen', 6000),
    Fields.URL('link'),
    Fields.String('forschungsgebiet'),
    Fields.Text('kurzbeschreibung', 6000),
    {
      label: 'Patent.form.ansprechpartner',
      field: 'ansprechpartner',
      schema: Person,
      icon: 'user',
      type: 'object',
      cardinality: 'single',
      render: 'stringRep',
      allowCreate: true,
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      }
    },
    {
      label: 'Patent.form.land',
      field: 'land',
      schema: Land,
      icon: 'globe',
      type: 'object',
      cardinality: 'many',
      render: 'stringRep',
      allowCreate: false,
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 2
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Patent.js